import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    space: '',
    totalArea: 0,
    areaDiamention: [],
    areaWidth: 0,
    areaHeight: 0,
    unit: '',
    tileWidth: 0,
    tileHeight: 0,
    tileArea: 0,
    totalTiles: 0,
    calculateArea: false,
    groute: 0,
    tilesPerBox: [],
}

export const calculatorSlice = createSlice({
    name: 'calculator',
    initialState: initialState,
    reducers: {
        setTilesCalculatorData: (state, action) => {
            return { ...state, ...action.payload };
        },
        addSpace: (state, action) => {
            state.space = action.payload;
           
        },
        addTotalArea: (state, action) => {
            state.totalArea = action.payload;
           
        },
        addAreaDiamention: (state, action) => {
            state.areaDiamention = [...state.areaDiamention, action.payload];

        },
        emptyAreaDiamention: (state, action) => {
            state.areaDiamention = [];
        },
        addAreaWidth: (state, action) => {
            state.areaWidth = action.payload;
           
        },
        addAreaHeight: (state, action) => {
            state.areaHeight = action.payload;
           
        },
        addUnit: (state, action) => {
            state.unit = action.payload;
           
        },
        addTileArea: (state, action) => {
            state.tileArea = action.payload;
           
        },
        addTileWidth: (state, action) => {
            state.tileWidth = action.payload;
        },
        addTileHeight: (state, action) => {
            state.tileHeight = action.payload;
        },
        addTotalTiles: (state, action) => {
            state.totalTiles = action.payload;
        },
        calculateAreaClicked: (state, action) => {
            state.calculateArea = action.payload;
        },
        addGroute: (state, action) => {
            state.groute = action.payload;
        },
        addTilesPerBox: (state, action) => {
            state.tilesPerBox = action.payload;
        },
        allTilescalculation: (state, action) => {
            const totalArea_mm = state.unit == "feet" ? state.totalArea * 304.8 : state.totalArea * 1000;
            const newTileArea = state.groute > 0 ? ((state.tileWidth + state.groute) * (state.tileHeight + state.groute)) : state.tileArea;
            if (newTileArea !== 0) {
                // Calculate totalTiles based on the unit
                state.totalTiles = state.unit === "meter"
                    ? Math.ceil((totalArea_mm / newTileArea) * 1000)
                    : Math.ceil((totalArea_mm / newTileArea) * 304.8);
            } else {
                // Handle the case when newTileArea is zero
                state.totalTiles = 0; // Or any default value or error handling
            }
        }
    }
})


export const {
    setTilesCalculatorData,
    addSpace,
    addTotalArea,
    addAreaDiamention,
    addAreaWidth,
    addAreaHeight,
    addUnit,
    addTileArea,
    calculateAreaClicked,
    addTotalTiles,
    addGroute,
    addTilesPerBox,
    addTileWidth,
    addTileHeight,
    allTilescalculation,
    emptyAreaDiamention } = calculatorSlice.actions;

export default calculatorSlice.reducer;